import { Helmet } from 'react-helmet-async';
import { useTheme } from 'styled-components';

const ThemeHelmet = () => {
	const { colors, isDark } = useTheme();

	return (
		<Helmet>
			<html data-theme={isDark ? 'dark' : 'light'} />
			<meta content={colors.metaColor} name="theme-color" />
		</Helmet>
	);
};

export { ThemeHelmet };
